import styles from "./COIResultsApprovalViewer.module.css";
import { COIConflictMatch, COI_DECISIONS } from "../../../../firm_setup/ConflictCheckResults/ConflictCheckResults.types";

export const decisionBadgeClass = (decision?: string | null) =>
  decision === COI_DECISIONS.PROCEED
    ? styles.decisionBadgeProceed
    : decision === COI_DECISIONS.STOP
      ? styles.decisionBadgeStop
      : styles.decisionBadgePending;

export const registryClientDisplayName = (match: COIConflictMatch): string | null => {
  if (!match.ClientId && !match.ClientName) return null;
  return [match.ClientId, match.ClientName].filter(Boolean).join(" - ");
};

export const affiliateIsSecClientLabel = (match: COIConflictMatch): string | null => {
  if (match.AffiliateIndividualSECClient === "Y") return "Yes";
  if (match.AffiliateIndividualSECClient === "N") return "No";
  return null;
};
